import React from "react";
import { Box, Stack } from "@mui/system";
import { Button, Container, Grid, Typography } from "@mui/material";
import CustomAppBar from "../../../components/CustomAppBar";
import { useNavigate } from "react-router";
import RoundButton from "../../../components/RoundButton";
import styled from "styled-components";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MenuBar from "../../menuBar";
import { useResponsive } from "../../../hooks/useResponsive";
import { useTranslation } from "react-i18next";

const UploadReservationDocumentsPage = () => {
  const navigate = useNavigate();
  const lgUp = useResponsive("up", "lg");
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <CustomAppBar
        title={"Reservations"}
        showBackButton={true}
        onBackButtonClick={() => {
          navigate(-1);
        }}
      />
      <MenuBar />
      <Container
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Grid container direction={"column"} sx={{ mt: 2 }}>
          <Typography variant="h5" color={"primary.main"}>
            {t("pages.uploadDocumentsPage.pageHeading")}
          </Typography>
          <Typography
            variant="body2"
            sx={{ mt: 1 }}
            color={"primary.secondary"}
          >
            {t("pages.uploadDocumentsPage.text01")}
          </Typography>
        </Grid>
        <Stack sx={{ mt: 2, mb: 2 }} spacing={2}>
          <Box>
            <Typography variant="h6" color={"primary.secondary"}>
              {t("pages.uploadDocumentsPage.text02")}{" "}
              <span style={{ color: "#C50F1F" }}>*</span>
            </Typography>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<CloudUploadIcon />}
              style={{
                backgroundColor: "#fff",
                color: "#1D5AB9",
                borderWidth: 2,
                borderColor: "#1D5AB9",
                marginBottom: 20,
              }}
              disabled={false}
              component="label"
            >
              {t("pages.uploadDocumentsPage.text03")}
              <VisuallyHiddenInput
                type="file"
                onChange={() => {}}
                accept="image/png, image/jpeg, application/pdf"
              />
            </Button>
          </Box>
          <Box>
            <Typography variant="h6" color={"primary.secondary"}>
              {t("pages.uploadDocumentsPage.text04")}{" "}
              <span style={{ color: "#C50F1F" }}>*</span>
            </Typography>
            <Button
              variant="outlined"
              // size={"large"}
              fullWidth
              startIcon={<CloudUploadIcon />}
              style={{
                backgroundColor: "#fff",
                color: "#1D5AB9",
                borderWidth: 2,
                borderColor: "#1D5AB9",
                marginBottom: 20,
              }}
              disabled={false}
              component="label"
            >
              {t("pages.uploadDocumentsPage.text03")}
              <VisuallyHiddenInput
                type="file"
                onChange={() => {}}
                accept="image/png, image/jpeg, application/pdf"
              />
            </Button>
          </Box>
        </Stack>
        <Stack
          sx={{ mt: 2, mb: 2, position: "absolute", bottom: 0, width: "90%" }}
          spacing={2}
        >
          <RoundButton
            style={{}}
            sx={{ mt: 5, mb: 3 }}
            size="large"
            fullWidth
            variant="contained"
            type="submit"
            color="primary"
            rounded
            onClick={() => {
              navigate("/reservation_details");
            }}
          >
            <Typography variant="buttonText" color="common.buttonText">
              {t("commonLabels.text17")}
            </Typography>
          </RoundButton>
        </Stack>
      </Container>
    </div>
  );
};

export default UploadReservationDocumentsPage;
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
